export default __webpack_public_path__ + "static/media/DR_HITESH_KUMAR_1_11_22.203375e9.wav";